// NPM Imports
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { ContentState } from "draft-js";
import uuid from "react-native-uuid";

// Components Imports
import ComponentCloneBtn from "./ComponentCloneBtn";
import ComponentClauseBtn from "./ComponentClauseBtn";
import ComponentClauseOptionBtn from "./ComponentClauseOptionBtn";
import ComponentDeleteBtn from "./ComponentDeleteBtn";
import ComponentImgEditBtn from "./ComponentImgEditBtn";
import DocumentItemPopups from "./DocumentItemPopups";
import ComponentLockBtn from "./ComponentLockBtn";
import ComponentManageColumnBtn from "./ComponentManageColumnBtn";

// Actions Imports
import {
  updateDocumentClickedComponentID,
  forceUpdateEditorSectionIdAction,
  coverpageThemeAction,
} from "../../../actions/DocumentActions/index";
import {
  addClause,
  saveClause,
  removeClause,
} from "../../../actions/DocumentTemplateActions/templateActions";
import { ToolbarActions, QuotationActions } from "../../../actions";

// Services Imports

// Internal Imports
import { DOCUMENTS } from "../../../constants";
import { DocumentUtils } from "../../../utils";
import { getContentStateFromRawSectionData } from "../../../utils/components";

// Methods Imports
import { updateSecInDocReduxAndBackend } from "../methods";
import SignTagPropertiesBtn from "./SignTagPropertiesBtn";
import { TOOLPANE_TTITLE } from "../../../constants/toolpane";

const { SIGN_TAG_PROPERTIES } = TOOLPANE_TTITLE;
// Destructuring
const { checkTableDataSource } = DocumentUtils;
const {
  toggleTabView,
  setSectionDataForActiveSignatureInRightToolPane,
  setSectionDataForActivePaymentButtonInRightToolPane,
  setSidePaneDataForPageNo,
} = QuotationActions;
const {
  updateAddComponentinToolbarAction,
  updateToolpaneViewTypeSignProperties,
} = ToolbarActions;
const {
  COMPONENT_FEATURE,
  DOCUMENT_COMPONENT_TYPES,
  DOCUMENT_MODE,
  STACK_IGNORE_LIST,
} = DOCUMENTS;

const _isEmptyContainer = type => {
  if (type === DOCUMENT_COMPONENT_TYPES.EMPTY_CONTAINER) {
    return true;
  }
  return false;
};

class DocumentItemActionBtns extends PureComponent {
  state = {
    showClauseSave: false,
    showDeleteConfirmation: false,
    showRemoveClauseConfirmation: false,
    showRemoveClauseOptionsConfirmation: false,
    showAddComponentBtns: false,
    showContentLockUpgradePopup: false,
    showAddClauseUpgradePopup: false,
    showManageColumnPopup: false,
    columnsHeaders: [],

    openModal: false,
    showRemoveTableFormField: false,
  };

  _deleteSection = () => {
    const { section } = this.props;
    if (section.type === DOCUMENT_COMPONENT_TYPES.PAGE_NUMBER) {
      this.props.setSidePaneDataForPageNo({});
      this.props.updateDocumentClickedComponentID(null, true, null);
    } else if (
      section.type === DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER
    ) {
      this.props.setSectionDataForActiveSignatureInRightToolPane({});
      if (!this.props.isPdfDocument) {
        this.props.updateAddComponentinToolbarAction("doc-components");
      }
    } else if (
      section.type === DOCUMENT_COMPONENT_TYPES.STRIPE_PAYMENT_BUTTON
    ) {
      this.props.setSectionDataForActivePaymentButtonInRightToolPane({});
      this.props.updateAddComponentinToolbarAction("doc-components");
    } else if (section.type === DOCUMENT_COMPONENT_TYPES.TABLE) {
      this.props.coverpageThemeAction(null);
    }
    this.props.deleteComponent(section.id, section);
  };

  _handleDeleteButton = () => {
    if (STACK_IGNORE_LIST.includes(this.props.section.type)) {
      this.setState({ showDeleteConfirmation: true });
    } else {
      this._deleteSection();
    }
    return null;
  };

  _handleSignPropertiesClick = signer_identity_id => {
    this.props.updateToolpaneViewTypeSignProperties(
      SIGN_TAG_PROPERTIES,
      true,
      signer_identity_id,
    );
  };

  _toggleUpgradePopup = (type, flag) => {
    this.setState({ [type]: flag });
  };

  _updateStateKey = (type, value) => {
    this.setState({ [type]: value });
  };

  _closePopup = () => {
    this.setState({
      openModal: false,
    });
  };

  _createClause = clauseName => {
    const { section, updateComponent } = this.props;
    const clauseId = uuid.v4();
    saveClause(clauseName, clauseId, section).then(response => {
      const clause = { id: response.Clause.id, name: response.Clause.name };
      this.props.addClause(clause);
      const newSection = {
        ...section,
        clauseID: clauseId,
        lock: true,
        componentMeta: this.props.componentMeta,
      };
      updateComponent(newSection, undefined, false, newSection);
      this._closeClausePopUp();
    });
  };

  _addAltText = () => {
    const { section } = this.props;
    this.setState({
      openModal: true,
    });
    this.props.disablePlusBtnHandler(false);
    this.props.updateDocumentClickedComponentID(
      section.id,
      false,
      section.type,
    );
  };

  _setMngColsData = (hdnCols, newColHdrs) => {
    const { section } = this.props;
    const currentSec = { ...section };

    if (
      section &&
      (section.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET ||
        section.type === DOCUMENT_COMPONENT_TYPES.TABLE ||
        section.data.attributes.showManageColumnOption)
    ) {
      const newSection = {
        ...section,
        data: {
          attributes: {},
          ...section.data,
        },
      };
      newSection.data.attributes.hiddenCols = hdnCols;
      if (
        "columnCount" in newSection.data.attributes &&
        "originalColumnCount" in newSection.data.attributes
      ) {
        newSection.data.attributes.columnCount =
          newSection.data.attributes.originalColumnCount - hdnCols.length;
      }
      updateSecInDocReduxAndBackend(newSection, currentSec);
    }

    this.setState({
      columnsHeaders: newColHdrs,
    });
    this.props.updateGsheetHiddenColumn(hdnCols);
  };

  _removeClause = () => {
    const { section, updateComponent } = this.props;
    const { clauseID } = section;
    this.props.removeClause(clauseID);
    const newSection = {
      ...section,
      clauseID: null,
      lock: false,
      componentMeta: this.props.componentMeta,
    };
    updateComponent(newSection, undefined, false, newSection);
  };

  _removeClauseOption = () => {
    const { mode, section } = this.props;
    // check if clause option feature is allowed for this mode or not
    if (COMPONENT_FEATURE[mode].createClauseOption) {
      const updatedSection = {
        ...section,
        clauseOptions: null,
        form_field: [],
        componentMeta: this.props.componentMeta,
      };
      this.props.updateComponent(
        updatedSection,
        undefined,
        false,
        section,
        undefined,
        undefined,
        true, // to update the redux as well in this call
      );
    }
  };

  _showManageColumnsForTable = () => {
    const columnsHeaders = this._createColumnHeaders(this.props.section);
    this.setState({
      showManageColumnPopup: true,
      columnsHeaders,
    });
  };

  _getPlanTextFromCellData = cellData => {
    const { data, html } = cellData;
    let value = "";
    if (html) {
      value = html;
    } else {
      const rawData = data;
      let contentState = null;
      if (rawData instanceof ContentState) {
        contentState = rawData;
      } else {
        contentState = getContentStateFromRawSectionData(
          { data: rawData },
          this.props.mode,
        );
      }
      value = contentState ? contentState.getPlainText() : "";
    }
    return value;
  };

  _createColumnHeaders = section => {
    if (
      section &&
      section.data &&
      section.data.data &&
      section.data.data.length > 0
    ) {
      const firstRowData = section.data.data[0].data;
      const columnHeaders = [];
      const dataSource = checkTableDataSource(section);
      firstRowData.forEach((col, index) => {
        let colName = "";
        if (col.data.html || col.data) {
          const span = document.createElement("span");
          if (section.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET) {
            span.innerHTML = this._getPlanTextFromCellData(col.data);
          } else if (!dataSource && typeof col.data === "string") {
            span.innerHTML = col.data;
          } else if (!dataSource) {
            span.innerHTML = col.data.data.getPlainText();
          } else if (
            dataSource === DOCUMENT_COMPONENT_TYPES.DEAL_TABLE &&
            typeof col.data === "string"
          ) {
            span.innerHTML = col.data;
          } else if (dataSource === DOCUMENT_COMPONENT_TYPES.DEAL_TABLE) {
            span.innerHTML = col.data.data.getPlainText();
          } else if (dataSource === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET) {
            span.innerHTML = this._getPlanTextFromCellData(col.data);
          }
          colName = span.textContent || span.innerText;
        }
        let show = true;
        if (
          this.props.section &&
          this.props.section.data &&
          this.props.section.data.attributes &&
          this.props.section.data.attributes.hiddenCols &&
          this.props.section.data.attributes.hiddenCols.includes(index)
        ) {
          show = false;
        }
        const colHeader = { id: index, name: colName, show };
        columnHeaders.push(colHeader);
      });
      return columnHeaders;
    }
    return [];
  };

  _convertToClause = () => {
    this.setState({ showClauseSave: true });
  };

  _closeClausePopUp = () => {
    this.setState({ showClauseSave: false });
  };

  _showRemoveClausePopup = () => {
    this.setState({ showRemoveClauseConfirmation: true });
  };

  _handleComponentLockUnlock = lockStatus => {
    this.props.handleComponentLockUnlock(this.props.section, lockStatus);
  };

  render() {
    const isEmptyComponent = _isEmptyContainer(this.props.section.type);

    let sudoClass = "";
    let lockedCaseClassName = "";
    if (this.props.mode === DOCUMENT_MODE.TEMPLATE) {
      sudoClass = " sudo-class ";
      if (this.props.totalRowItems > 2) {
        sudoClass += " reduce-width ";
      }
    } else if (
      this.props.mode === DOCUMENT_MODE.DOCUMENT &&
      this.props.section.lock
    ) {
      lockedCaseClassName = "locked-component-action";
    }
    return (
      <>
        {/* -------- Popups section -------- */}
        <DocumentItemPopups
          sectionLabel={this.props.section.label}
          toggleUpgradePopup={this._toggleUpgradePopup}
          openModal={this.state.openModal}
          showClauseSave={this.state.showClauseSave}
          sectionIdForClause={this.state.sectionIdForClause}
          showDeleteConfirmation={this.state.showDeleteConfirmation}
          showRemoveClauseConfirmation={this.state.showRemoveClauseConfirmation}
          showRemoveClauseOptionsConfirmation={
            this.state.showRemoveClauseOptionsConfirmation
          }
          showRemoveTableFormField={this.state.showRemoveTableFormField}
          showManageColumnPopup={this.state.showManageColumnPopup}
          showContentLockUpgradePopup={this.state.showContentLockUpgradePopup}
          showAddClauseUpgradePopup={this.state.showAddClauseUpgradePopup}
          createClause={this._createClause}
          closePopup={this._closePopup}
          updateDocumentClickedComponentID={
            this.props.updateDocumentClickedComponentID
          }
          updateStateKey={this._updateStateKey}
          deleteSection={this._deleteSection}
          docDeletePopupRef={this.props.docDeletePopupRef}
          columnsHeaders={this.state.columnsHeaders}
          setMngColsData={this._setMngColsData}
          removeClause={this._removeClause}
          removeClauseOption={this._removeClauseOption}
          section={
            this.props.section && this.props.section.type === "Image"
              ? this.props.section
              : undefined
          }
          updateComponent={
            this.props.section && this.props.section.type === "Image"
              ? this.props.updateComponent
              : undefined
          }
        />

        {/* -------- Action buttons section -------- */}
        {!isEmptyComponent &&
          this.props.isComponentActive &&
          !this.state.showAddComponentBtns &&
          !this.props.isPdfDocument &&
          !this.props.isLocked && (
            <div
              ref={this.props.sectionActionBtnsRef}
              className={`component-wrapper ${
                !this.props.isLocked ? "drag-button-space" : ""
              } ${this.props.section.type === "Table" ? "table-wrapper" : ""}`}
              data-test="documentitems-component-wrapper-template-component-doc-view">
              <div
                className={`component-action ${
                  !this.props.isLocked ? "action-padding" : ""
                } ${sudoClass} ${lockedCaseClassName}`}
                data-test="documentitems-component-action-template-component-doc-view">
                <ComponentDeleteBtn
                  handleDeleteButton={this._handleDeleteButton}
                  mode={this.props.mode}
                  section={this.props.section}
                />
                <ComponentCloneBtn
                  clauseOptionsDetails={this.props.clauseOptionsDetails}
                  cloneSection={this.props.cloneSection}
                  mode={this.props.mode}
                  sectionType={this.props.section.type}
                />
                <ComponentClauseBtn
                  mode={this.props.mode}
                  sectionType={this.props.section.type}
                  sectionId={this.props.section.id}
                  clauseID={this.props.section.clauseID}
                  clauseOptions={this.props.section.clauseOptions}
                  convertToClause={this._convertToClause}
                  showRemoveClausePopup={this._showRemoveClausePopup}
                />
                <ComponentLockBtn
                  mode={this.props.mode}
                  clauseOptionsDetails={this.props.clauseOptionsDetails}
                  handleComponentLockUnlock={this._handleComponentLockUnlock}
                  toggleUpgradePopup={this._toggleUpgradePopup}
                  sectionType={this.props.section.type}
                  clauseID={this.props.section.clauseID}
                  lock={this.props.section.lock}
                />
                <ComponentImgEditBtn
                  mode={this.props.mode}
                  totalRowItems={this.props.totalRowItems}
                  sectionType={this.props.section.type}
                  clauseOptions={this.props.section.clauseOptions}
                  lock={this.props.section.lock}
                  sectionData={this.props.section.data}
                  addAltText={this._addAltText}
                  clearReplaceImage={this.props.clearReplaceImage}
                />
                <ComponentManageColumnBtn
                  showManageColumnsForTable={this._showManageColumnsForTable}
                  section={this.props.section}
                />
                <ComponentClauseOptionBtn
                  mode={this.props.mode}
                  section={this.props.section}
                  itemType={this.props.itemType}
                  clauseOptionsDetails={this.props.clauseOptionsDetails}
                  toggleUpgradePopup={this._toggleUpgradePopup}
                  updateStateKey={this._updateStateKey}
                />
                <SignTagPropertiesBtn
                  mode={this.props.mode}
                  section={this.props.section}
                  handleButtonClick={this._handleSignPropertiesClick}
                />
              </div>
            </div>
          )}

        {!isEmptyComponent &&
          this.props.isPdfDocument &&
          !this.props.isSharedDocument &&
          (this.props.stage === "DRAFT" ||
            this.props.templateStatus === "DRAFT") && (
            <div
              ref={this.sectionActionBtnsRef}
              className={`component-wrapper ${
                this.props.section.type === "Table" ? "table-wrapper" : ""
              }`}
              data-test="documentitems-component-wrapper-template-component-doc-view">
              <div
                className={`component-action ${
                  !this.props.isLocked ? "action-padding" : ""
                } ${sudoClass}`}
                data-test="documentitems-component-action-template-component-doc-view">
                <ComponentDeleteBtn
                  handleDeleteButton={this._handleDeleteButton}
                  mode={this.props.mode}
                  section={this.props.section}
                />
                <SignTagPropertiesBtn
                  mode={this.props.mode}
                  section={this.props.section}
                  handleButtonClick={this._handleSignPropertiesClick}
                />
              </div>
            </div>
          )}
      </>
    );
  }
}

const mapDispatchToProps = {
  addClause,
  removeClause,
  toggleTabView,
  updateAddComponentinToolbarAction,
  setSectionDataForActiveSignatureInRightToolPane,
  updateDocumentClickedComponentID,
  setSectionDataForActivePaymentButtonInRightToolPane,
  forceUpdateEditorSectionIdAction,
  coverpageThemeAction,
  setSidePaneDataForPageNo,
  updateToolpaneViewTypeSignProperties,
};

export default connect(null, mapDispatchToProps)(DocumentItemActionBtns);
